import { Component, computed, input, output } from '@angular/core';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { ImagePreviewDirective } from '@examdojo/ui/image-preview';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'dojo-chat-images-list-item',
  standalone: true,
  templateUrl: './chat-images-list-item.component.html',
  styles: [
    `
      .chat-images-remove-button ::ng-deep .ion-icon-button.button-solid {
        --background: theme('colors.red.500');
        --background-hover: theme('colors.red.400');
        --background-focused: theme('colors.red.500');
        --border-color: white;
        --color: white;
        --border-width: 1px;
        --border-radius: 50%;

        &::part(native) {
          padding: calc(0.25rem - var(--border-width));
          min-height: 22px;
          min-width: 22px;
        }

        &:hover {
          --background: theme('colors.red.400');
          --background-hover: theme('colors.red.400');

          &.ion-activated {
            --background: theme('colors.red.500');
          }
        }

        &.ion-activated,
        &.ion-focused {
          --background: theme('colors.red.500');

          &::part(native) {
            outline: 2px solid theme('colors.sky.500');
            outline-offset: -2px;
          }
        }
      }
    `,
  ],
  imports: [IconButtonComponent, ImagePreviewDirective, MatTooltip, TranslocoPipe],
  host: {
    class: 'relative',
  },
})
export class ChatImagesListItemComponent {
  readonly base64String = input.required<string>();

  readonly editable = input<boolean>(false);

  readonly removeImage = output();

  // TODO: update data:{{format}} after API will support image type as input
  readonly dataUrl = computed(() => `data:text/plain;base64,${this.base64String()}`);
}
